export const SCHEMA_VERSION = 1;

export interface AppState {
  schemaVersion: number;
  config: AppConfig;
  versions: VersionSnapshot[];
}

export interface AppConfig {
  dataSheetName: string;
  dataTableName: string | null;
  keyColumns: string[];
  headerRowCount: number;
  topRowsToSkip: number;
  columnsToIgnore: string[];
  lastOpenedAt: string;
}

export interface VersionSnapshot {
  id: string;
  label: string;
  savedAt: string;
  columns: string[];
  rows: Record<string, string>[];
}

export const MAX_VERSIONS = 20;
export const KEY_SEPARATOR = "";

export function keyOf(row: Record<string, string>, keyColumns: string[]): string {
  return keyColumns.map((c) => String(row[c] ?? "").trim()).join(KEY_SEPARATOR);
}

export function displayKey(row: Record<string, string>, keyColumns: string[]): string {
  return keyColumns
    .map((c) => String(row[c] ?? "").trim())
    .filter(Boolean)
    .join(" ");
}
